import { journey1 } from './journey-1.js';
import { journey2 } from './journey-2.js';
import { journey3 } from './journey-3.js';
import { journey4 } from './journey-4.js';
import { reel2 } from './reel-2.js';
import { reel3 } from './reel-3.js';
import { reel4 } from './reel-4.js';
import { resetMeTime } from './reset-me-time.js';
import { serviceStock } from './service-stock.js';
import { skinEdit } from './skin-edit.js';
import { stepByStep } from './step-by-step.js';
export const AUTHORED_TEMPLATES = [
    journey1,
    journey2,
    journey3,
    journey4,
    reel2,
    reel3,
    reel4,
    resetMeTime,
    serviceStock,
    skinEdit,
    stepByStep,
];
export { journey1, journey2, journey3, journey4, reel2, reel3, reel4, resetMeTime, serviceStock, skinEdit, stepByStep, };
//# sourceMappingURL=index.js.map